import { GenericRemoteActionBuilder } from '../remote-action-builder';
import { Injectable, ViewContainerRef, ComponentRef } from '@angular/core';
import { LoggingService } from 'src/app/_services/logging/logic/logging.service';
import { ClientStateService } from 'src/app/_services/client-state/logic/client-state.service';
import { RemoteAction } from '../../remote-action';
import { TimeCorrectionRemoteActionBuilderUiStep } from '../../remote-action-builder-steps/time-correction-remote-action-builder-ui-step/time-correction-remote-action-builder-ui-step';
import { TimeCorrectionComponent } from 'src/app/_components/remote-action-step/time-correction/time-correction.component';
import { LocationService } from 'src/app/_services/location/location.service';
import { EmployeeService } from 'src/app/_services/employee/logic/employee.service';
import { AppService } from 'src/app/_services/app-service/logic/app.service';
import { CredentialsService } from 'src/app/_services/credentials/logic/credentials.service';
import { GpsRemoteActionBuilderServiceStep } from '../../remote-action-builder-steps/gps-remote-action-builder-service-step/gps-remote-action-builder-service-step';
import { AppParameterService } from 'src/app/_services/app-parameter/logic/app-parameter.service';
import { TeamRemoteActionBuilderServiceStep } from '../../remote-action-builder-steps/team-remote-action-builder-service-step/team-remote-action-builder-service-step';

@Injectable()
export class PassengerTripEndActionBuilder extends GenericRemoteActionBuilder {
  constructor(
    private clientStateService: ClientStateService,
    appService: AppService,
    credentialsService: CredentialsService,
    employeeService: EmployeeService,
    locationService: LocationService,
    private appParameterService: AppParameterService,
    private logger?: LoggingService
  ) {
    super(
      'PASSENGER-TRIP-END-REMOTEACTION.PAGE-TITLE',
      appService,
      credentialsService,
      {
        endpoint: 'driverpassengeridentification',
        data: {},
        cachable: true,
        fifo: true,
        authenticationRequired: true,
        shortLabel: 'PASSENGER-TRIP-END-REMOTEACTION.RA.LABEL.SHORT',
        shortLabelTranslate: true,
      },
      [new TimeCorrectionRemoteActionBuilderUiStep(logger)],
      [
        new TeamRemoteActionBuilderServiceStep(
          employeeService,
          clientStateService,
          logger
        ),
        new GpsRemoteActionBuilderServiceStep(locationService, logger),
      ],
      async (data: any) => {
        logger.log(
          this.constructor.name,
          ' Executing post generate function',
          data
        );
        this.clientStateService.setIsPassenger(false);
      },
      logger
    );
  }

  public async next(dataValues?: { key: string; value: any }[]): Promise<any> {
    return super.next(dataValues);
  }

  public async generateRemoteAction(
    dataValues: { key: string; value: any }[]
  ): Promise<RemoteAction> {
    const ra: RemoteAction = await super.generateRemoteAction(dataValues);
    return ra;
  }

  public generateComponent(
    viewContainerRef: ViewContainerRef
  ): ComponentRef<any> {
    const componentRef = super.generateComponent(viewContainerRef);
    const appParams = this.appParameterService.appParameters$.getValue();
    // Configure specific Components
    if (componentRef.instance instanceof TimeCorrectionComponent) {
      (<TimeCorrectionComponent>componentRef.instance).setDescription(
        'PASSENGER-TRIP-END-REMOTEACTION.DESCRIPTION'
      );
      (<TimeCorrectionComponent>componentRef.instance).setTitle(
        'PASSENGER-TRIP-END-REMOTEACTION.TITLE'
      );
      (<TimeCorrectionComponent>componentRef.instance).showDPEnd =
        appParams.getBooleanParameter(
          'imsmc.remoteaction-step.passenger-trip-end.allow-end',
          false
        );
      (<TimeCorrectionComponent>componentRef.instance).showDPEot =
        appParams.getBooleanParameter(
          'imsmc.remoteaction-step.passenger-trip-end.allow-eot',
          false
        );
    }

    return componentRef;
  }
}
